import Game from 'app/records/game'
import React, { PropTypes } from 'react'
import Strings from 'config/strings'
import TeamGif from '../team-gif'

export default React.createClass({

  propTypes: {
    game : PropTypes.instanceOf(Game).isRequired
  },

  render() {
    const { game } = this.props

    return (
      <main className="round-starting fill-black">
        <div className="container">
          <TeamGif team={ Game.getWinner(game) } short />

          <div className="row">
            <div className="col round-starting__team no-vs fill-blue">
              { game.team_1.name }<br/>
              { game.team_1.score }
            </div>
            <div className="col round-starting__team fill-red">
              { game.team_2.name }<br/>
              { game.team_2.score }
            </div>
          </div>

          { Game.isTie(game) ? this.renderTie() : this.renderLoser(Game.getLoser(game)) }

          <a href="/" className="round-starting__submit">
            Play Again
          </a>
        </div>
      </main>
    )
  },

  renderTie() {
    return (
      <div className="turn-finished__title">
        There was no winner, so I guess you both lost...
      </div>
    )
  },

  renderLoser(team) {
    return (
      <div className="turn-finished__title game-finished__title">
        <p>Team { team.name } lost :(</p>
        <p>Well. You tried.</p>
      </div>
    )
  }
})



/** WEBPACK FOOTER **
 ** ./web/static/app/components/game/phases/game-finished.jsx
 **/